<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Add Compliance Item'"
      [canGoBack]="!windowService.isDesktopRes" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper [class]="isRightSideContent ? 'right-side-scroll-enabled' : ''">

    @if (loaded) {
      @if (errorMessage) {
        <tidy-error-message
          [text]="errorMessage" />
      }
      <tidy-card>
        <form [formGroup]="form" novalidate action="#">
          <tidy-row>
            <tidy-select
              [label]="'Property'"
              [form]="form.controls.property"
              formControlName="property"
              [items]="addressItems"
              [icon]="'assets/svg/home-outline.svg'"
              [submitted]="submitted"
              [errorMessage]="'Please select a property'" />
          </tidy-row>
          <tidy-row>
            <tidy-input
              [label]="'Name'"
              formControlName="name"
              [form]="form.controls.name"
              [icon]="'assets/svg/clipboard-outline.svg'"
              [submitted]="submitted"
              [errorMessage]="'Please enter a name'" />
          </tidy-row>
          <tidy-row>
            <tidy-select
              [label]="'Category'"
              [form]="form.controls.bucket"
              formControlName="bucket"
              [items]="bucketItems"
              [icon]="'assets/svg/list-outline.svg'"
              [submitted]="submitted"
              [errorMessage]="'Please select a category'" />
          </tidy-row>
          <tidy-row>
            <tidy-textarea
              label="What To Do"
              formControlName="what_to_do"
              [form]="form.controls.what_to_do"
              [icon]="'assets/svg/create-outline.svg'" />
          </tidy-row>
          <tidy-row>
            <tidy-textarea
              label="How To Do It"
              formControlName="how_to_do_it"
              [form]="form.controls.how_to_do_it"
              [icon]="'assets/svg/build-outline.svg'" />
          </tidy-row>
          <tidy-row>
            <tidy-select
              [label]="'Frequency'"
              [form]="form.controls.frequency"
              formControlName="frequency"
              [items]="frequencyItems"
              [icon]="'assets/svg/repeat-outline.svg'" />
          </tidy-row>
          <tidy-row>
            <tidy-datepicker
              [label]="'Next Due Date'"
              formControlName="next_due_at"
              [form]="form.controls.next_due_at"
              [icon]="'assets/svg/calendar-outline.svg'" />
          </tidy-row>
          <tidy-row>
            <tidy-input
              [label]="'Jurisdiction'"
              formControlName="jurisdiction"
              [form]="form.controls.jurisdiction"
              [icon]="'assets/svg/location-outline.svg'" />
          </tidy-row>
          <tidy-row>
            <tidy-textarea
              label="Notes"
              formControlName="notes"
              [form]="form.controls.notes"
              [icon]="'assets/svg/create-outline.svg'" />
          </tidy-row>
          <tidy-row>
            <tidy-toggle
              [toggled]="form.get('is_tax')?.value"
              (toggleChanged)="form.get('is_tax')?.setValue(!form.get('is_tax')?.value)" />
            <tidy-text [body]="'This is a tax-related item'" />
          </tidy-row>
          @if (form.get('is_tax')?.value) {
            <tidy-row>
              <tidy-input
                [label]="'Tax Rate (in cents, e.g. 600 = 6%)'"
                formControlName="tax_rate_cents"
                [form]="form.controls.tax_rate_cents"
                [icon]="'assets/svg/calculator-outline.svg'"
                [type]="'number'" />
            </tidy-row>
          }
        </form>
      </tidy-card>
      <tidy-button
        [text]="'Save'"
        [action]="saveItemAction"
        class="primary" />
    }
  </tidy-wrapper>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
